import { connect } from 'react-redux';
import { getProjectsForUser } from '../../actions/projectActions';
import StudentProfileProjects from './StudentProfileProjects';

export default connect(null, {
  getProjectsForUser,
})(StudentProfileProjects);
